import { PageSkeleton } from '@sellsen/components';
import { Navigate, Outlet } from 'react-router-dom';
import { ROLES } from '../../constants/roles';
import { useCurrentRoles } from '../../hooks/use-current-roles';

/** Depo paneli gibi tüm kullanıcıların verisini gösteren sayfalar: yalnız ROLE_ADMIN. */
export function RequireAdmin() {
  const { roles, isLoading } = useCurrentRoles();

  if (isLoading) {
    return <PageSkeleton />;
  }

  if (!roles.has(ROLES.ADMIN)) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
